import { Component, Input, ViewChild } from '@angular/core';
import { LogoComponent } from "../logo/logo.component";
import { CommonModule } from '@angular/common';
import { SidebarStateService } from '../../../core/services/sidebar-state.service';
import { TranslocoPipe } from '@jsverse/transloco';
import { LogoutDialogComponent } from "../../../features/auth/components/logout-dialog/logout-dialog.component";
import { Router, RouterLink } from '@angular/router';
import { UserDataService } from '../../../core/services/user-data.service';
import { PrimaryButtonComponent } from "../primary-button/primary-button.component";
import { SubscriptionService } from '../../../core/services/subscription.service';
import { Permission } from '../../../core/interfaces/payment-interfaces';

@Component({
  selector: 'app-desktop-sidebar',
  standalone: true,
  imports: [LogoComponent, CommonModule, TranslocoPipe, LogoutDialogComponent, PrimaryButtonComponent, RouterLink],
  templateUrl: './desktop-sidebar.component.html',
  styleUrl: './desktop-sidebar.component.css'
})
export class DesktopSidebarComponent {
  @Input() selectedItemId: number = 0;
  @ViewChild(LogoutDialogComponent) logoutDialog!: LogoutDialogComponent;

  isOpen$ = this.sidebarService.isOpen$;

  get isUserOnTrial(): boolean {
    return this.userData.getUser()?.membership?.membership_type === 'TRIAL';
  }

  get trialDaysLeft(): string {
    if (this.isUserOnTrial) {
      const validToStr = this.userData.getUser()?.membership?.valid_to;
      if (validToStr) {
        const validTo = new Date(validToStr);
        const currentDate = new Date();
        const timeDiff = validTo.getTime() - currentDate.getTime();
        const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

        return daysLeft > 0 ? `${daysLeft > 99 ? '99+' : daysLeft}` : "0";
      }
    }
    return '';
  }

  constructor(private sidebarService: SidebarStateService, private router: Router, private userData: UserDataService, private subscriptionService: SubscriptionService) { }

  toggleSidebar() {
    this.sidebarService.toggleSidebar();
  }

  getSidebarState(): boolean {
    return this.sidebarService.getSidebarState();
  }

  getSidebarOpenState(): boolean {
    return this.sidebarService.getSidebarOpenState();
  }

  async logoutUser() {
    var dialogResponse = await this.logoutDialog.openModal();
    if (!dialogResponse) {
      return;
    }
    this.router.navigate(['/auth/logout']);
  }

  openPlansPage() {
    this.router.navigate(['/settings/plans']);
  }

  hoverSidebar(state: boolean) {
    this.sidebarService.setHovered(state);
  }

  hoverSidebarChange() {
    this.sidebarService.setHovered(!this.sidebarService.getHovered());
  }

  get hasDashboardViewPermission(): boolean {
    const user = this.userData.getUser();
    const membership = user?.membership;

    if (!membership) {
      return false;
    }

    if (user && user.is_active && this.subscriptionService.membershipHasPermission(membership, Permission.VIEW_DASHBOARD, true)) {
      return true;
    }
    return false;
  }
}
